import { render, staticRenderFns } from "./LoyaltyRewards.vue?vue&type=template&id=a927d016&"
import script from "./LoyaltyRewards.vue?vue&type=script&lang=js&"
export * from "./LoyaltyRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports